import SearchBarcode from "./SearchBarcode";
export default SearchBarcode;
